import dayjs from '@/services/date'
import parseTimeStringToObject from '@/utils/parse-time-string-to-object'
import config from '@/common/config'
import { PermissionScope } from '@/shared/constants/permissions/PermissionScope'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getSelectedClients: 'client/getSelectedClients',
      getAllClientLocationsWithPermission:
        'auth/getAllClientLocationsWithPermission',
    }),
    compSameDayCutOffObject() {
      try {
        return parseTimeStringToObject(config.get('sameDayBookingCutOffTime'))
      } catch (ex) {
        console.warn(
          'Failed to parse same day cut off time. Defaulting to 8:00 am'
        )
        return { hours: 8, minutes: 0 }
      }
    },
    /**
     * TODO: Re-write to handle multi-client.
     * Should also be relocated into component as this logic isn't shared
     * and will make the implementation less complex.
     */
    hasAtLeastOneLocationNotPassedSameDayCutOff() {
      const locations = this.getAllClientLocationsWithPermission(
        this.getSelectedClients[0],
        PermissionScope.BOOKING
      )

      if (!locations || locations.length < 0) return false

      for (const location of locations) {
        if (!this.hasPassedSameDayCutOff(location.timeZone)) return true
      }

      return false
    },
  },
  methods: {
    convertDateToTimezone(date, tz) {
      return dayjs(date).tz(tz)
    },
    hasPassedSameDayCutOff(timezone) {
      const today = dayjs().tz(timezone)
      const cutOff = dayjs()
        .tz(timezone)
        .startOf('day')
        .add(this.compSameDayCutOffObject)

      return today.isAfter(cutOff)
    },
  },
}
